import React, { Component } from 'react'
import connexion from '../../connexion'
import logo from '../../images/logo-pc-default.png'
import { XCircleIcon } from '@heroicons/react/solid'
import './Signin.css'

class Signin extends Component {
	constructor(props) {
		super(props)
		this.state = {
			form: {
				login: "",
				password: "",
				remember_me: false
			},
			attempt_submit: false,
			error: null,
			show_password: false,
		}
		this.updateUser = props.updateUser
	}

	// Écran fixe sur téléphone : la page derrière ne défile plus et prend le fond de l'écran
	componentDidMount()
	{
		const root = document.documentElement
		const body = document.body
		this.previousStyles = { rootOverflow: root.style.overflow, bodyOverflow: body.style.overflow, rootBackground: root.style.background, bodyBackground: body.style.background }
		root.style.overflow = 'hidden'
		body.style.overflow = 'hidden'
		root.style.background = '#F4F4F4'
		body.style.background = '#F4F4F4'
	}

	componentWillUnmount()
	{
		const root = document.documentElement
		const body = document.body
		root.style.overflow = this.previousStyles.rootOverflow
		body.style.overflow = this.previousStyles.bodyOverflow
		root.style.background = this.previousStyles.rootBackground
		body.style.background = this.previousStyles.bodyBackground
	}

	handleLogin = (event) => {
		let form = {
			login: event.target.value,
			password: this.state.form.password,
			remember_me: this.state.form.remember_me
		}
		this.setState({ form: form })
	}

	handlePassword = (event) => {
		let form = {
			login: this.state.form.login,
			password: event.target.value,
			remember_me: this.state.form.remember_me
		}
		this.setState({ form: form })
	}

	handleRememberMe = (event) => {
		let form = {
			login: this.state.form.login,
			password: this.state.form.password,
			remember_me: event.target.checked
		}
		this.setState({ form: form })
	}

	handleSubmit = (event) => {
		event.preventDefault()
		this.setState({ attempt_submit: true })
		fetch(connexion.connect.url + 'dashboard/users/login', {
			method: 'POST',
			body: JSON.stringify({
				login: this.state.form.login,
				password: this.state.form.password,
				remember_me: this.state.form.remember_me,
				screen: window.screen.width + 'x' + window.screen.height,
				color_depth: window.screen.colorDepth,
				timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				platform: navigator.platform,
				language: navigator.language
			})
		})
		.then(res => res.json())
		.then(user => {
			if (user !== false)
				this.updateUser(user)
			else
				this.setState({ error: 'Identifiant ou mot de passe incorrect.', attempt_submit: false })
		})
		.catch(err => {
			this.setState({ error: 'Une erreur s\'est produite.', attempt_submit: false })
			console.log(err)
		})
	}

	render() {
		const error = this.state.error
		const sending = this.state.attempt_submit === true
		const showPassword = this.state.show_password
		const label = { display: 'block', fontSize: 14, fontWeight: 600, color: '#334155', marginBottom: 6 }
		return (
			<div className="signin-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: 'max(16px, env(safe-area-inset-top)) 16px max(16px, env(safe-area-inset-bottom))', boxSizing: 'border-box' }}>
				<main style={{ flex: 1, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<form onSubmit={this.handleSubmit} className="bg-white border border-slate-200 rounded-2xl shadow-sm" style={{ width: '100%', maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 18, padding: 'clamp(24px, 6vw, 36px)', boxSizing: 'border-box' }}>
						<img src={logo} alt="Pocketcamp" style={{ height: 44, width: 'auto', display: 'block', alignSelf: 'flex-start', marginBottom: 8 }} />
						<div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 6 }}>
							<p className="text-2xs font-black text-slate-400 uppercase tracking-widest" style={{ margin: 0 }}>Dashboard</p>
							<h1 className="text-slate-900" style={{ margin: 0, fontFamily: "'Fraunces', Georgia, serif", fontSize: 'clamp(30px, 7.5vw, 36px)', fontWeight: 500, letterSpacing: '-0.02em', lineHeight: 1.1 }}>Content de vous revoir</h1>
						</div>
						<div>
							<label htmlFor="signin-login" style={label}>Identifiant</label>
							<input
								id="signin-login"
								type="text"
								required
								autoComplete="username"
								autoCapitalize="none"
								value={this.state.form.login}
								onChange={this.handleLogin}
							/>
						</div>
						<div>
							<label htmlFor="signin-password" style={label}>Mot de passe</label>
							<div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
								<input
									id="signin-password"
									className="signin-password"
									type={showPassword ? 'text' : 'password'}
									required
									autoComplete="current-password"
									value={this.state.form.password}
									onChange={this.handlePassword}
								/>
								<button
									type="button"
									className="signin-eye"
									aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
									aria-pressed={showPassword}
									onClick={() => this.setState({ show_password: !showPassword })}
									style={{ position: 'absolute', right: 2, width: 44, height: 44, border: 0, borderRadius: 10, backgroundImage: 'none', backgroundColor: 'transparent', color: '#64748B', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}
								>
									{showPassword
										? <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M3 3l18 18" /><path d="M10.6 5.1A10 10 0 0 1 12 5c6.5 0 10 7 10 7a17 17 0 0 1-3 3.9" /><path d="M6.6 6.6A17 17 0 0 0 2 12s3.5 7 10 7a9.7 9.7 0 0 0 4.4-1" /><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" /></svg>
										: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>}
								</button>
							</div>
						</div>
						<label htmlFor="remember_me" style={{ display: 'flex', alignItems: 'center', gap: 10, minHeight: 44, fontSize: 14, fontWeight: 500, color: '#334155', cursor: 'pointer' }}>
							<input
								type="checkbox"
								id="remember_me"
								checked={this.state.form.remember_me}
								onChange={this.handleRememberMe}
							/>
							Se souvenir de moi
						</label>
						{error && (
							<div role="alert" className="rounded-xl bg-rose-50 text-rose-700" style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', fontSize: 14, fontWeight: 600 }}>
								<XCircleIcon className="text-rose-500" style={{ width: 20, height: 20, flex: 'none' }} aria-hidden="true" />
								{error}
							</div>
						)}
						<button
							type="submit"
							className="signin-submit text-xs font-black uppercase tracking-widest shadow-sm"
							disabled={sending}
							style={{ height: 50, marginTop: 4, border: 0, borderRadius: 12, backgroundImage: 'none', backgroundColor: sending ? '#818CF8' : '#4F46E5', color: '#FFFFFF', fontFamily: 'inherit', cursor: sending ? 'wait' : 'pointer', transition: 'background-color 150ms ease-out, transform 120ms ease-out' }}
						>
							{sending ? 'Connexion…' : 'Se connecter'}
						</button>
					</form>
				</main>
				<footer className="text-xs font-medium text-slate-400" style={{ paddingTop: 16, textAlign: 'center' }}>Pocketcamp, conçu par et pour les campings indépendants</footer>
			</div>
		)
	}
}

export default Signin
